import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getIsProductCompareFull, getProductCompareChecked } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import addProductToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/AddProductToCompare";
import removeProductFromCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveProductFromCompare";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox/Checkbox";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { useContext, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    showCompare: boolean;
    extendedStyles?: ProductListCompareCheckboxStyles
}

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => ({
    productSettings: getSettingsCollection(state).productSettings,
    productCompareChecked: getProductCompareChecked(state, props.productContext),
    isProductCompareFull: getIsProductCompareFull(state),
});

const mapDispatchToProps = {
    addProductToCompare,
    removeProductFromCompare,
};

type Props = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps &
    HasProductContext;

export interface ProductListCompareCheckboxStyles {
    compareCheckbox?: CheckboxPresentationProps;
}

export const productListCompareCheckboxStyles: ProductListCompareCheckboxStyles = {
    compareCheckbox: {
        css: css`
            align-self: center;
            padding-top: 20px;
        `,
    },
};

const ProductListCompareCheckbox: React.FC<Props> = ({ 
    productContext,
    showCompare,
    productSettings,
    productCompareChecked,
    isProductCompareFull,
    extendedStyles,
    addProductToCompare,
    removeProductFromCompare,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const [styles] = useState(() => mergeToNew(productListCompareCheckboxStyles, extendedStyles));

    const handleChanged = (_: React.SyntheticEvent, value: boolean) => {
        if (value && isProductCompareFull) {
            toasterContext.addToast({
                body: siteMessage("ProductionCompare_MaximumItemsReached"),
                messageType: "warning",
            });
        } else if (value) {
            addProductToCompare({ productId: productContext.product.id });
        } else {
            removeProductFromCompare({ productId: productContext.product.id });
        }
    };

    if (!showCompare || !productSettings.enableProductComparisons) {
        return null;
    }

    return (
    <Checkbox
        {...styles.compareCheckbox}
        checked={productCompareChecked}
        onChange={handleChanged}
        data-test-selector="productList_CompareCheckbox"
    >
                {translate("Compare")}
    </Checkbox>)
};

export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductListCompareCheckbox));